import { CurrencyInput } from '../src/CurrencyInput';
import type { CurrencyInputProps, VatConfiguration, EventHandlerData } from '../src/CurrencyInput';

export { CurrencyInput };
export type { CurrencyInputProps, VatConfiguration, EventHandlerData };
export default CurrencyInput;
